
import { mapState, mapGetters } from "vuex";
import qrCode from "./qr-code.vue";
export default {
  components: { qrCode },
  computed: {
    ...mapState("restaurant", ["locationDetails", "businessDetails"]),
    ...mapGetters("reciever", ["getWhatsappConfig"])
  },
  props: {
    titleClassProp: {
      type: String,
      default:
        "foaps__text-small-5 font-weight-extrabold text-uppercase text-center black--text"
    },
    messageClassProp: {
      type: String,
      default:
        "foaps__text-small-2 font-weight-medium text-uppercase text-center black--text"
    }
  },
  methods: {
    isKotMarketingEnabled() {
      return this.getBoolean(this.$ls.get("kot-marketing", false));
    },
    getChannelUrl(channel) {
      let url = "";
      if (channel === "whatsapp") {
        url = this.getWhatsappOrderUrl(
          this.getWhatsappConfig.whatsapp_business_number
        );
      } else {
        // Search for the platform with the channel
        const selectedChannelObj =
          this.locationDetails.restaurants[0].restaurant_platforms.find(
            (platform) => platform.platform_name === channel
          );
        // setting the url
        if (selectedChannelObj) {
          url = selectedChannelObj.partner_url;
        }
      }
      return url;
    }
  }
};
